// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RenderNode_cellForDelete__lVk2j {
  outline: 1px dotted red;
  padding: "4px";
}

.RenderNode_showGrid__oIcPT {
  outline: 1px dotted #2680eb;
  padding: "4px";
}

.RenderNode_componentSelected__36MS0 {
  box-shadow: 0 0 10px #888888;
  outline: 0px solid transparent;
  z-index: 20;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), linear-gradient(to bottom, rgba(180, 180, 180, 0.3), rgba(180, 180, 180, 0.3));
  background-clip: padding-box, content-box;
  background-origin: border-box;
}

.RenderNode_buttonSelected__k6pcD {
  opacity: 0.5;
}

.RenderNode_indicatorDiv__IQGQP,
.RenderNode_pageIndicator__MGk6X {
  display: flex;
  position: absolute;
  margin-top: -29px;
  font-size: 12px;
  color: #fff;
  line-height: 15px;
  background-color: #2680eb;
  padding: 2px 0 2px 12px;
  z-index: 2;
  height: 26px;
}

.RenderNode_pageIndicator__MGk6X:before {
  content: " ";
  height: 0;
  position: absolute;
  width: 0;
  right: 18px;
  border: 8px solid transparent;
}

.RenderNode_nameDiv__qyhJu {
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.RenderNode_cursorMove__n3IsN {
  cursor: move;
  margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/TemplateEditor/components/RenderNode.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,2BAAA;EACA,cAAA;AACF;;AAEA;EAEE,4BAAA;EACA,8BAAA;EACA,WAAA;EACA,gLAAA;EAUA,yCAAA;EACA,6BAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;;EAEE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;AARF;;AAWA;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,6BAAA;AARF;;AAWA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AARF;;AAWA;EACE,YAAA;EACA,mBAAA;AARF","sourcesContent":[".cellForDelete {\n  outline: 1px dotted red;\n  padding: '4px';\n}\n\n.showGrid {\n  outline: 1px dotted #2680eb;\n  padding: '4px';\n}\n\n.componentSelected {\n  -webkit-box-shadow: 0 0 10px #888888;\n  box-shadow: 0 0 10px #888888;\n  outline: 0px solid transparent;\n  z-index: 20;\n  background-image: linear-gradient(\n      to bottom,\n      rgba(255, 255, 255, 0.3),\n      rgba(255, 255, 255, 0.3)\n    ),\n    linear-gradient(\n      to bottom,\n      rgba(180, 180, 180, 0.3),\n      rgba(180, 180, 180, 0.3)\n    );\n  background-clip: padding-box, content-box;\n  background-origin: border-box;\n}\n\n.buttonSelected {\n  opacity: 0.5;\n}\n\n.indicatorDiv,\n.pageIndicator {\n  display: flex;\n  position: absolute;\n  margin-top: -29px;\n  font-size: 12px;\n  color: #fff;\n  line-height: 15px;\n  background-color: #2680eb;\n  padding: 2px 0 2px 12px;\n  z-index: 2;\n  height: 26px;\n}\n\n.pageIndicator:before {\n  content: ' ';\n  height: 0;\n  position: absolute;\n  width: 0;\n  right: 18px;\n  border: 8px solid transparent;\n}\n\n.nameDiv {\n  margin-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.cursorMove {\n  cursor: move;\n  margin-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cellForDelete": `RenderNode_cellForDelete__lVk2j`,
	"showGrid": `RenderNode_showGrid__oIcPT`,
	"componentSelected": `RenderNode_componentSelected__36MS0`,
	"buttonSelected": `RenderNode_buttonSelected__k6pcD`,
	"indicatorDiv": `RenderNode_indicatorDiv__IQGQP`,
	"pageIndicator": `RenderNode_pageIndicator__MGk6X`,
	"nameDiv": `RenderNode_nameDiv__qyhJu`,
	"cursorMove": `RenderNode_cursorMove__n3IsN`
};
export default ___CSS_LOADER_EXPORT___;
